import { 
        InfoContainer, 
        InfoWrapper, 
        InfoRow, 
        Column1, 
        Column2,
        TextWrapper, 
        TopLine, 
        Heading, 
        Subtitle, 
        ImgWrap, 
        Img 
} from './InfoElements'

const InfoSection = ({ topLine, headline, description, img, alt }) => {
  return (
    <>
       <InfoContainer id='about2'>
            <InfoWrapper id='about'>
                <InfoRow >
                    <Column1>
                        <TextWrapper>
                            <TopLine>{topLine}</TopLine>
                            <Heading>{headline}</Heading>
                            <Subtitle>{description}</Subtitle>
                        </TextWrapper>
                    </Column1>
                    <Column2>
                        <ImgWrap>
                            <Img src={img} alt={alt} />
                        </ImgWrap>
                    </Column2>
                </InfoRow>
            </InfoWrapper>
        </InfoContainer> 
    </>
  )
}

export default InfoSection